import { transformDataToAlgoliaAnalytics } from '@tracking/transforms/algolia';

export const eventNames = {
    EVENT_CONNECT: 'Connect With Attendees',
    EVENT_PROPERTIES: 'Properties',
};

export const sendToAlgoliaAnalytics = data => {
    if (!window.aa) return;
    if (data?.excludeService && data.excludeService.find(val => val === 'Algolia')) return;
    if (!data?.unfiltered?.click?.index || !data?.unfiltered?.click?.hit) return; // nulls prod errors

    const { type } = data;
    const readyData = transformDataToAlgoliaAnalytics(data);

    switch (type) {
        case 'click':
            console.log('click: readyData sent to Algolia Analytics', readyData);
            window.aa('clickedObjectIDsAfterSearch', readyData);
            break;
        case 'conversion':
            console.log('conversion: readyData sent to Algolia Analytics', readyData);
            window.aa('convertedObjectIDsAfterSearch', readyData);
            break;
        default:
            console.error('No datatype for tracking provided. Data not sent to Algolia analytics.');
            break;
    }
};
